import { sqliteTable, text, index } from "drizzle-orm/sqlite-core";
import { crmOrganizations } from "./organizations";

// ============================================================================
// crm_contacts — ผู้ติดต่อ
// ============================================================================
export const crmContacts = sqliteTable("crm_contacts", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  salutation: text("salutation"),
  firstName: text("first_name"),
  lastName: text("last_name"),
  fullName: text("full_name"),
  jobTitle: text("job_title"),
  email: text("email"),
  phone: text("phone"),
  mobile: text("mobile"),
  lineId: text("line_id"),
  organizationId: text("organization_id").references(() => crmOrganizations.id),
  customerId: text("customer_id"), // FK → customers (accounting) — no constraint
  remarks: text("remarks"),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyIdx: index("contact_company_idx").on(table.companyId),
  companyOrgIdx: index("contact_company_org_idx").on(table.companyId, table.organizationId),
}));

// Type exports
export type CrmContact = typeof crmContacts.$inferSelect;
export type NewCrmContact = typeof crmContacts.$inferInsert;
